<template>
  <div>
    <template>
      <v-btn
        color="secondary"
        rounded
        dark
        @click="showDialog"
        style="color: #01288d"
      >
        Add New Vehicle
      </v-btn>
    </template>
    <WarningModal
      :handleConfirm="handleConfirm"
      v-if="$store.getters['Dashboard/showWarningModal']"
    />

    <SuccessModal v-if="$store.getters['Dashboard/showSuccessModal']" />
    <ErrorModal v-if="$store.getters['Dashboard/showErrorModal']" />
    <v-dialog
      v-model="$store.getters['Dashboard/vehicleCreationModal']"
      persistent
      max-width="800px"
    >
      <v-card
        color="#f4f7fc"
        style="
        background: white;
        border-radius: 2rem;
        "
      >
        <v-btn
          x-small
          outlined
          @click="hideDialog"
          fab
          icon
          class="float-right mt-5 mr-5"
        >
          <v-icon c>
            mdi-close
          </v-icon>
        </v-btn>
        <v-card-title>
          <span
            style="font-family: inherit !important"
            class="text-h5 text-md-h4"
          >
            New Vehicle Details
            <br />
            <span style="font-family: inherit !important;" class="text-body-1">
              Please Fill Vehicle registration details</span
            >
          </span>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <!-- Tabs for different steppers -->

            <v-tabs
              v-model="tab"
              grow
              class="d-none d-md-block mt-md-8 mb-md-8"
            >
              <v-tabs-slider color="secondary"></v-tabs-slider>
              <v-tab ref="registrationData">REGISTRATION DETAILS</v-tab>
              <v-tab ref="insuranceData">INSURANCE DETAILS</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row v-if="bio">
                  <v-col cols="12">
                    <span class="text-uppercase">Type of vehicle</span>
                    <v-select
                      filled
                      rounded
                      dense
                      class="mt-2"
                      placeholder="Select Vehicle Type"
                      :items="$store.getters['Dashboard/vehicleTypes']"
                      :item-text="'name'"
                      :item-value="'id'"
                      v-model="formData.vehicle_type_id"
                      name="vehicleType"
                      :rules="stepOneRules.vehicle_type_id"
                      ref="vehicle_type_id"
                    ></v-select>

                    <span class="text-uppercase"
                      >Vehicle Registration Number</span
                    >
                    <v-text-field
                      flat
                      dense
                      class="mt-2"
                      filled
                      rounded
                      placeholder="Enter Registration Number"
                      v-model="formData.reg_no"
                      :rules="stepOneRules.reg_no"
                      ref="reg_no"
                    ></v-text-field>

                    <span class="text-uppercase">Insurance Certificate No</span>
                    <v-text-field
                      filled
                      rounded
                      dense
                      class="mt-2"
                      placeholder="Enter Certificate Number"
                      v-model="formData.insurance_cert_no"
                      :rules="stepOneRules.insurance_cert_no"
                      ref="insurance_cert_no"
                    ></v-text-field>

                    <span class="text-uppercase">Insurance Company </span>
                    <v-text-field
                      filled
                      rounded
                      dense
                      class="mt-2"
                      placeholder="Enter Insurance Company"
                      v-model="formData.insurance_company"
                      :rules="stepOneRules.insurance_company"
                      ref="insurance_company"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    class="d-flex flex-column flex-sm-row justify-space-around"
                  >
                    <v-btn
                      large
                      rounded
                      style="background-color: white; border: 2px solid #01288d !important; padding: 0 4rem;"
                      class="primary--text mb-8 mb-sm-0"
                    >
                      Back
                    </v-btn>
                    <v-btn
                      large
                      rounded
                      @click="handleNextClick"
                      color="secondary"
                      class="primary--text"
                      style="padding: 0 4rem"
                    >
                      Proceed
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="12">
                    <span class="text-uppercase">Insurance Expiry Date</span>
                    <v-menu
                      v-model="showPicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="selectedDate"
                          label="Choose the date"
                          persistent-hint
                          readonly
                          v-on="on"
                          class="mb-4"
                          flat
                          filled
                          rounded
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="selectedDate"
                        no-title
                        @input="showPicker = false"
                      ></v-date-picker>
                    </v-menu>
                    <span class="text-uppercase">Log Book Number</span>
                    <v-text-field
                      flat
                      filled
                      rounded
                      dense
                      class="mt-2"
                      placeholder="Enter Log Number"
                      v-model="formData.log_book_no"
                      :rules="stepTwoRules.log_book_no"
                      ref="log_book_no"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-file-input
                      flat
                      filled
                      rounded
                      dense
                      label="Insurance Certificate"
                      type="file"
                      color="secondary"
                      v-model="formData.insurance_cert"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    class="d-flex flex-column flex-sm-row justify-space-around"
                  >
                    <v-btn
                      large
                      rounded
                      @click="$refs.registrationData.$el.click()"
                      style="background-color: white; border: 2px solid #01288d !important; padding: 0 4rem;"
                      class="primary--text mb-8 md-sm-0"
                    >
                      Back
                    </v-btn>
                    <v-btn
                      large
                      rounded
                      color="secondary"
                      style="padding: 0 4rem"
                      class="primary--text"
                      :loading="modalLoading"
                      @click="handleSubmit"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { AuthService } from "@/modules/auth";
import WarningModal from "@/components/Dashboard/Modals/WarningModal";
import SuccessModal from "@/components/Dashboard/Modals/SuccessModal";
import ErrorModal from "@/components/Dashboard/Modals/ErrorModal";
export default {
  name: "AddVehicle",
  props: ["vehicle"],
  components: {
    WarningModal,
    SuccessModal,
    ErrorModal
  },
  data: () => ({
    bio: true,
    modalLoading: false,
    tab: null,
    showPicker: false,
    selectedDate: null,
    formData: {
      vehicle_type_id: "",
      reg_no: "",
      insurance_expiry_date: "",
      insurance_cert_no: "",
      insurance_company: "",
      log_book_no: "",
      insurance_cert: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    stepOneRules() {
      return {
        vehicle_type_id: [value => !!value || "Required."],
        reg_no: [value => !!value || "Required."],
        insurance_company: [value => !!value || "Required."],
        insurance_cert_no: [value => !!value || "Required."]
      };
    },
    stepTwoRules() {
      return {
        log_book_no: [value => !!value || "Required."]
      };
    },

    userId() {
      const user = AuthService.getUser();
      return user.id;
    }
  },

  created() {
    this.$store.dispatch("Dashboard/fetchVehicleTypes");
  },

  mounted() {
    Event.$on("modalLoading", value => {
      this.modalLoading = value;
    });
  },

  methods: {
    handleNextClick() {
      let isValid = true;

      for (let key in this.stepOneRules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }
      if (isValid) {
        this.$refs.insuranceData.$el.click();
      }
    },

    handleSubmit() {
      let isValid = true;

      for (let key in this.stepTwoRules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        const formatedDate = this.selectedDate
          .split("-")
          .reverse()
          .join("-");
        // this.formData.owner_id = this.userId;
        // this.formData.insurance_expiry_date = formatedDate;
        // delete this.formData.owner;
        // delete this.formData.vehicle_type;
        // delete this.formData.created_at;
        // delete this.formData.updated_at;

        const newFormData = new FormData();

        if (this.formData.insurance_cert instanceof File)
          newFormData.append(
            "insurance_cert",
            this.formData.insurance_cert,
            this.formData.insurance_cert.name
          );

        newFormData.append("vehicle_type_id", this.formData.vehicle_type_id);
        newFormData.append("reg_no", this.formData.reg_no);
        newFormData.append("owner_id", this.userId);
        newFormData.append("insurance_expiry_date", formatedDate);
        newFormData.append(
          "insurance_company",
          this.formData.insurance_company
        );
        newFormData.append("log_book_no", this.formData.log_book_no);
        newFormData.append(
          "insurance_cert_no",
          this.formData.insurance_cert_no
        );

        this.$store.dispatch("Dashboard/addNewVehicle", newFormData);
      }
    },

    handleSecondStep() {
      this.dialog = false;
      this.dialogTwo = true;
    },

    hideDialog() {
      this.$store.dispatch("Dashboard/hideVehicleCreationModal");
    },

    showDialog() {
      this.$store.dispatch("Dashboard/showVehicleCreationModal");
    },

    handleConfirm() {
      this.$store.dispatch("Dashboard/deleteVehicle", this.vehicle);
    }
  }
};
</script>

<style scoped></style>
